export default {
      id: "print-usage",
      viewBox: "796 675.578 200 200",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#print",
      toString: function () {
        return this.url;
      }
    }